import {
  INITIAL,
  PENDING,
  COMPLETED,
  FAILED,
} from "src/engine/modules/constants"
import get from "lodash/get"
import {
  UPDATE_CALENDAR_EVENT_STATUS,
  UPDATE_EVENT_STATUS,
  UPDATE_EVENT_STATUS_FAILED,
  REQUEST_STATUS_TRANSITION_LIST,
  REQUEST_STATUS_TRANSITION_LIST_SUCCEEDED,
  REQUEST_STATUS_TRANSITION_LIST_FAILED,
  READ_ALL_AVAILABLE_STATUSES,
  READ_ALL_AVAILABLE_STATUSES_FAILED,
  READ_ALL_AVAILABLE_STATUSES_SUCCEEDED,
} from "../actions/types"

export const INITIAL_STATE = {
  transitions: [],
  status: INITIAL,
  all: [],
  allStatus: INITIAL,
}

export default function validateReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // Обновление статуса на календаре
    case UPDATE_CALENDAR_EVENT_STATUS:
      return {
        ...state,
        status: PENDING,
      }

    // Обновление статуса в форме события
    case UPDATE_EVENT_STATUS:
      return {
        ...state,
        status: PENDING,
      }

    case UPDATE_EVENT_STATUS_FAILED:
      return {
        ...state,
        status: FAILED,
      }
    // Обновление списка переходов
    case REQUEST_STATUS_TRANSITION_LIST:
      return {
        ...state,
        status: PENDING,
      }
    case REQUEST_STATUS_TRANSITION_LIST_SUCCEEDED:
      return {
        ...state,
        status: COMPLETED,
        transitions: get(action, `action.data`),
      }
    case REQUEST_STATUS_TRANSITION_LIST_FAILED:
      return {
        ...state,
        status: FAILED,
      }

    // Список всех доступных статусов
    case READ_ALL_AVAILABLE_STATUSES:
      return {
        ...state,
        allStatus: PENDING,
      }
    case READ_ALL_AVAILABLE_STATUSES_SUCCEEDED:
      return {
        ...state,
        allStatus: COMPLETED,
        all: get(action, `action.data`),
      }
    case READ_ALL_AVAILABLE_STATUSES_FAILED:
      return {
        ...state,
        allStatus: FAILED,
      }
    default:
      return state
  }
}
